export const DUPLICATE_INSTANCES_CODE = 409;
